import { IBondGrossMarketReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_GROSS_YIELD_SHEKEL_MARKET';

export type IReportGrossYieldShekelMarketItem = IBondGrossMarketReport & { __isSelected: boolean };
